import BenchmarkCompare from './BenchmarkCompare';

export default BenchmarkCompare;
